<script setup lang="ts">
import WelcomeItem from './WelcomeItem.vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faCow,
  faStore,
  faTruckLoading,
  faFileInvoiceDollar,
  faChartPie,
  faUsers
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faCow, faStore, faTruckLoading, faFileInvoiceDollar, faChartPie, faUsers)

const features = [
  {
    title: 'Livestock Precision',
    icon: ['fas', 'cow'],
    description: 'Advanced tracking for poultry, cattle, and more—monitoring every stage from breeding to health.',
    link: '/animals'
  },
  {
    title: 'Retail POS Hub',
    icon: ['fas', 'store'],
    description: 'Unified sales control for your Butcher, Grocery, and LocalHarvest shops with automated inventory.',
    link: '/shops/butcher/sales'
  },
  {
    title: 'Operational Logistics',
    icon: ['fas', 'truck-loading'],
    description: 'Complete equipment maintenance, fuel monitoring, and resource optimization for maximum uptime.',
    link: '/equipment'
  },
  {
    title: 'Financial Insights',
    icon: ['fas', 'file-invoice-dollar'],
    description: 'Automated reporting and expense analysis to drive profitability and operational clarity.',
    link: '/admin/reports'
  },
  {
    title: 'Workforce Hub',
    icon: ['fas', 'users'],
    description: 'Professional staff management with performance tracking and emergency response logging.',
    link: '/workers'
  },
  {
    title: 'Strategic Analytics',
    icon: ['fas', 'chart-pie'],
    description: 'Deep-dive data analytics that transform raw operational numbers into actionable business vision.',
    link: '/finance'
  }
]
</script>

<template>
  <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
    <WelcomeItem
      v-for="(feature, index) in features"
      :key="feature.title"
      :class="`animate-on-scroll opacity-0 translate-y-10 transition-all duration-700 delay-${(index % 3) * 100}`"
    >
      <template #icon>
        <div class="flex items-center justify-center w-12 h-12 rounded-xl bg-gradient-to-br from-green-500 to-emerald-600 text-white shadow-lg">
          <FontAwesomeIcon :icon="feature.icon" />
        </div>
      </template>
      <template #heading>{{ feature.title }}</template>
      <p class="text-gray-600 leading-relaxed">{{ feature.description }}</p>
      <RouterLink
        v-if="feature.link"
        :to="feature.link"
        class="mt-4 inline-flex items-center text-sm font-bold text-green-700 hover:text-green-900 transition-colors group"
      >
        Open Module
        <svg class="ml-2 w-4 h-4 transform group-hover:translate-x-1 transition-transform" fill="currentColor" viewBox="0 0 20 20">
          <path fill-rule="evenodd" d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z" clip-rule="evenodd" />
        </svg>
      </RouterLink>
    </WelcomeItem>
  </div>
</template>

<style scoped>
.animate-on-scroll {
  transition: all 0.7s cubic-bezier(0.16, 1, 0.3, 1);
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.animate-fadeInUp {
  animation: fadeInUp 0.8s ease-out forwards;
}
</style>
